var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302,
    height: 80.654,
    viewBox: "0 0 302 80.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(-201.545 -431.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(201.545 431.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M222.348,470.121c.08-.459.087-.613.367-2.359,1.088-6.79-6.82-11.176-6.82-11.176s8.459-2.6,9.034-11.89c.495-8.008-8.585-18.942-23.344-10.847a.09.09,0,0,0-.018.133.1.1,0,0,0,.059.036A.114.114,0,0,0,201.7,434a11.863,11.863,0,1,1,9.443,21.64c-.076.023-.072.113,0,.146,1.873.851,6.68,4.393,5.242,11.982-.1.5-.222,1.269-.278,1.591-2.524,14.427,13.761,18.705,13.761,18.705A17.935,17.935,0,0,1,222.348,470.121Z",
    transform: "translate(-201.545 -431.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M279.7,490.437s-5.755-1.128-10.071-.222a14.432,14.432,0,0,0-11.35,13.233c-.647,12.049,10.657,12.45,10.5,24.757a15.208,15.208,0,0,1-13.945,14.628.172.172,0,0,0-.034.341,17.539,17.539,0,0,0,20.56-15.97c1.158-11.906-10.576-16.495-10.137-24.888.349-6.664,4.573-12.073,14.458-11.716A.082.082,0,0,0,279.7,490.437Z",
    transform: "translate(-230.261 -462.822)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(273.019 457.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14",
    transform: "translate(32.31 0.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M464.437,520.888v-9.467a5.317,5.317,0,0,1-5.052,4.734A5.317,5.317,0,0,1,464.437,520.888Z",
    transform: "translate(-444.717 -501.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    "data-name": "Trazado 51",
    d: "M452.993,513.858c-.491,2.207-3.194,4.962-6,6.325a5.145,5.145,0,0,1-2.249.493h-9.172a3.975,3.975,0,0,0,2.395-3.645V494.723a3.949,3.949,0,0,0-2.41-3.634h8.662a5.446,5.446,0,0,1,3.417,1.162,10.981,10.981,0,0,1,3.661,5.644v-6.2a.972.972,0,0,0-.972-.972H427.456s4.6.958,4.543,5.052v20.208c0,2.632-4.543,5.052-4.543,5.052h24.565a.972.972,0,0,0,.972-.972Z",
    transform: "translate(-427.456 -490.721)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(128.904 0.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52",
    "data-name": "Trazado 52",
    d: "M674.7,520.888v-9.467a5.317,5.317,0,0,1-5.052,4.734A5.317,5.317,0,0,1,674.7,520.888Z",
    transform: "translate(-654.978 -501.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53",
    "data-name": "Trazado 53",
    d: "M663.254,513.858c-.489,2.2-3.177,4.945-5.975,6.311a5.11,5.11,0,0,1-2.247.5h-9.2a3.961,3.961,0,0,0,2.394-3.635V494.723a3.964,3.964,0,0,0-2.41-3.644h8.662a5.422,5.422,0,0,1,3.382,1.144,10.985,10.985,0,0,1,3.7,5.672v-6.2a.971.971,0,0,0-.971-.972H637.718s4.6.958,4.543,5.052v20.208c0,2.632-4.543,5.052-4.543,5.052l5.495,0,19.07,0a.971.971,0,0,0,.971-.972Z",
    transform: "translate(-637.718 -490.721)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M389.143,531.337c-3.554-1.086-5.2-4.434-6.2-6.538-2.547-5.37-.994-9.4-3.264-12.984a7.258,7.258,0,0,0-4.265-3.4.153.153,0,0,1,.005-.3c5.107-1.148,7.262-4.3,7.262-8.447,0-5.766-4.275-8.968-11.115-8.968H357.126s4.6.968,4.543,5.063v20.208c0,2.632-4.543,5.052-4.543,5.052h6.505a4,4,0,0,0,4-4V494.711a4.016,4.016,0,0,0-2.307-3.632l4.3-.008a5.946,5.946,0,0,1,4,1.466,9.654,9.654,0,0,1,2.92,7.128c0,5.249-4.465,7.892-5.554,8.488a.154.154,0,0,0,0,.27c4.756,2.733,2.65,10.885,6.62,17.325,3.593,5.828,8.446,5.763,11.485,5.9A.156.156,0,0,0,389.143,531.337Z",
    transform: "translate(-357.126 -490.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_55",
    "data-name": "Trazado 55",
    d: "M725.049,508.42a.149.149,0,0,1,.008-.29c5.124-1.135,7.3-4.3,7.3-8.464,0-5.128-3.536-8.968-11.393-8.968l-14.207.011s4.6.958,4.543,5.052v20.208c0,2.632-4.543,5.052-4.543,5.052h6.505a4,4,0,0,0,4-4V494.711a3.953,3.953,0,0,0-2.41-3.636h4.332a6.481,6.481,0,0,1,4.208,1.47,9.673,9.673,0,0,1,2.969,7.121c0,5.18-4.475,7.793-5.724,8.477-.139.076-.135.2,0,.286,5.635,3.535,2.093,13.631,10.686,13.631a7.505,7.505,0,0,0,4.888-1.554C729.914,521.023,732.07,509.685,725.049,508.42Z",
    transform: "translate(-546.137 -490.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    "data-name": "Trazado 56",
    d: "M585.745,489.993H575.5c2.015,1.06,3.06,2.933,3.267,6.094a6.857,6.857,0,0,1-.406,2.621L572.9,517.255c-.389,1.127-.786,2.351-1.886,2.351-.967,0-1.222-.656-1.785-2.583L563.1,496.06a9.007,9.007,0,0,0-8.687-6.665H550.2s5.126,1.189,6.389,5.47l6.981,22.186c1.159,3.482,3.633,3.646,5.937,3.646,2.775,0,3.244-1.9,3.772-3.355l5.5-18.688a24.67,24.67,0,0,1,1.021-2.528A13.109,13.109,0,0,1,585.745,489.993Z",
    transform: "translate(-461.501 -489.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M814.205,530.9a13.257,13.257,0,0,1-6.988-8.444l-8.762-28.943c-1.159-3.482-3.633-3.646-5.937-3.646-2.774,0-3.244,1.9-3.772,3.355l-5.5,18.688a24.685,24.685,0,0,1-1.022,2.528,13.105,13.105,0,0,1-5.948,6.133h10.245c-2.016-1.06-3.061-2.933-3.267-6.095a6.856,6.856,0,0,1,.406-2.621l5.465-18.546c.5-1.406.844-2.481,1.941-2.481.385,0,1.051.067,1.453,1.453l8.411,28.994a14.293,14.293,0,0,0,13.24,9.765A.074.074,0,0,0,814.205,530.9Z",
    transform: "translate(-583.721 -489.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58",
    "data-name": "Trazado 58",
    d: "M520.417,513.5c0-10.307-18.637-10.307-18.637-17.663,0-2.479,2.461-4.725,7.426-4.725a9.941,9.941,0,0,1,1.033.054,2.591,2.591,0,0,1,1.912,1.14c.966,1.492.582,3.551.578,4.149a2.993,2.993,0,1,0,5.986,0c0-5.477-6.784-5.721-9.417-5.73-7.757-.026-9.181,4.685-9.131,8.956.115,9.87,17.237,10.762,17.237,17.025a3.011,3.011,0,0,1-.216,1.058,4.824,4.824,0,0,1-3.323,2.872,14.141,14.141,0,0,1-7.128.04,5.22,5.22,0,0,1-2.107-1.093c-3.067-2.628-5.3-7.419-5.3-7.419l.043,8.873c1.175-1.907,3.989-.444,6.914.046a21.772,21.772,0,0,0,3.932.391,15.432,15.432,0,0,0,6.193-1.385l.009,0h0A6.89,6.89,0,0,0,520.417,513.5Z",
    transform: "translate(-434.003 -490.113)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_59",
    "data-name": "Trazado 59",
    d: "M852.593,547.771a2.632,2.632,0,0,1-2.634,2.629,2.622,2.622,0,1,1,2.634-2.629Zm-.326,0a2.293,2.293,0,1,0-2.308,2.282A2.264,2.264,0,0,0,852.267,547.771Zm-1.773.37.65.933h-.387l-.573-.871a1.134,1.134,0,0,1-.163.008h-.713v.864h-.325v-2.722h1.038c.7,0,1.084.332,1.084.91A.846.846,0,0,1,850.494,548.141Zm-.473-.215c.48,0,.767-.239.767-.656s-.287-.624-.767-.624h-.713v1.28Z",
    transform: "translate(-349.122 -61.712)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e392527cb2fabfb186a1131a871bb63e.svg";
export { ForwardRef as ReactComponent };